import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginEmployee, forgotPassword } from '../api';
import { useAuth } from '../AuthContext';
import '../App.css';

const Login = () => {
  const [formData, setFormData] = useState({ username: '', password: '', email: '' });
  const [error, setError] = useState('');
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setIsLoading(true);

    if (isForgotPassword) {
      try {
        const res = await forgotPassword({ email: formData.email });
        if (res.success) {
          setMessage('Password reset email sent successfully.');
          setTimeout(() => setIsForgotPassword(false), 2000);
        } else {
          setError(res.message || 'Failed to send email.');
        }
      } catch (err) {
        console.error("Forgot password error:", err);
        setError("Something went wrong. Please try again.");
      }
    } else {
      // Demo user check - get credentials from .env
      const demoUsername = process.env.REACT_APP_DEMO_USERNAME;
      const demoPassword = process.env.REACT_APP_DEMO_PASSWORD;
      
      if (
        formData.username.trim().toLowerCase() === demoUsername?.toLowerCase() &&
        formData.password === demoPassword
      ) {
        setUser({ username: demoUsername });
        navigate('/scrapper');
        setIsLoading(false);
        return;
      }
      try {
        const res = await loginEmployee(formData);
        if (res.success) {
          setUser(res.data.user);
          console.log("Login successful. User data:", res.data.user);
          navigate('/scrapper', { state: { user: res.data.user } });
        } else {
          setError(res.message || 'Login failed');
        }
      } catch (err) {
        console.error("Login error:", err);
        setError("Something went wrong. Please try again.");
      }
    }
    setIsLoading(false);
  };

  return (
    <div className="login-wrapper">
      <div className="login-container">
        <div className="login-box">
          {isForgotPassword ? (
            <>
              <h1 className="welcome-heading">Forget Password</h1>
              <form onSubmit={handleSubmit}>
                <div className="login-form">
                  <input
                    type="email"
                    className="login-input"
                    id="email"
                    placeholder="Enter your registered email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                  <button type="submit" className="home-btn" disabled={isLoading}>
                    {isLoading ? 'Sending...' : 'Send Mail'}
                  </button>
                </div>
                {message && <p className="success-message">{message}</p>}
                {error && <p className="login-error">{error}</p>}
              </form>
              <p onClick={() => setIsForgotPassword(false)} className="login-link">Back</p>
            </>
          ) : (
            <>
              <h1 className="welcome-heading">Login</h1>
              <form onSubmit={handleSubmit}>
                <div className="login-form">
                  <input
                    type="text"
                    className="login-input"
                    id="username"
                    placeholder="Username"
                    value={formData.username}
                    onChange={handleChange}
                    required
                    disabled={isLoading}
                  />
                  <input
                    type="password"
                    className="login-input"
                    id="password"
                    placeholder="Password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                    disabled={isLoading}
                  />
                  <button type="submit" className="home-btn" disabled={isLoading}>
                    {isLoading ? 'Signing in...' : 'Login'}
                  </button>
                </div>
                {error && <p className="login-error">{error}</p>}
              </form>
              <p onClick={() => setIsForgotPassword(true)} className="login-link">Forgot Password?</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;
